import { Component, ElementRef, OnInit } from '@angular/core'
import { IonModal } from '@ionic/angular/standalone'

import { PrettyJsonPipe } from '../../pipes/pretty-json.pipe'
import { DebuggingService } from './services/debugging.service'

@Component({
	selector: 'app-debugging-modal',
	templateUrl: './debugging-modal.component.html',
	styleUrls: ['./debugging-modal.component.scss'],
	standalone: true,
	imports: [IonModal, PrettyJsonPipe],
})
export class DebuggingModalComponent implements OnInit {
	constructor(
		protected readonly debuggingService: DebuggingService,
		private readonly elementRef: ElementRef,
	) {}

	ngOnInit() {
		// Move this component to the document's body tag
		document.body.appendChild(this.elementRef.nativeElement)
	}
}
